import { FC, ReactElement } from 'react';

import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { Bets } from '../../config/bets';
import { useHighflyerGameStateSlice } from '../../store/slices/highflyerGame/selectors';
import { BetStepperConnected } from '../betStepper/BetStepperConnected';
import { useShowCollapsedMode } from '../betStepper/useShowCollapsedMode';
import { BettingFooterConnected } from '../bettingFooter/BettingFooterConnected';
import { GameBetButtonConnected } from '../GameBetButton/GameBetButtonConnected';
import { useBetboardCanBeHidden } from '../gameGrid/hooks';
import { QuickBetWing } from '../quickbets/QuickBetWing';

import styles from './bettingActionConnected.module.css';

export interface BettingActionConnectedProps {
  betCode: Bets;
}
export const BettingActionConnected: FC<BettingActionConnectedProps> = ({ betCode }): ReactElement | null => {
  const isSecondBetBoardEnabled = useHighflyerGameStateSlice.getIsSecondBetBoardToggle();
  const showCollapsedMode = useShowCollapsedMode(betCode);
  const betboardCanbeHidden = useBetboardCanBeHidden();

  const mods = useModifiers(styles, 'betting_action_wing', {
    maximizeGameBtn: showCollapsedMode,
    singleBetBoard: !isSecondBetBoardEnabled,
  });

  if (!isSecondBetBoardEnabled && betboardCanbeHidden === betCode) return null;
  return (
    <div className={`${styles.betting_action_wing} ${mods}`}>
      <BetStepperConnected betCode={betCode} />
      <QuickBetWing betCode={betCode} />
      <GameBetButtonConnected betCode={betCode} />
      <BettingFooterConnected betCode={betCode} />
    </div>
  );
};
